module.exports = __webpack_public_path__ + "static/media/facebook-icon.d8aa1135.svg";